/* src/app/components/confirm-modal/confirm-modal.component.scss */
.header-icon {
  width: 40px;
  height: 40px;
}
.text {
  font-family: "Barlow Semi Condensed", sans-serif;
  font-weight: 500;
  font-size: 22px;
  text-align: center;
}
.subtext {
  font-family: "Barlow Semi Condensed", sans-serif;
  font-weight: 400;
  font-size: 16px;
  color: #949494;
  text-align: center;
}
ion-button {
  font-size: 18px;
  font-weight: 600;
  margin: 0;
}
/*# sourceMappingURL=confirm-modal.component-UNRZ2VQQ.css.map */
